/**
 * Code QR généré dans le navigateur (librairie qrcode) — aucun service externe.
 * Toujours noir sur blanc, même en thème sombre : les lecteurs de QR lisent mal l’inverse.
 */
import { useEffect, useState } from 'react'
import QRCode from 'qrcode'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  /** Côté en pixels (affichage). */
  size?: number
  /** Texte alternatif ; par défaut « Code QR : <value> ». */
  label?: string
  className?: string
}

export function QrCode({ value, size = 160, label, className }: Props) {
  const { t } = useTranslation('common')
  const [dataUrl, setDataUrl] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    QRCode.toDataURL(value, { margin: 1, width: size * 2, errorCorrectionLevel: 'M' })
      .then((url) => {
        if (!cancelled) setDataUrl(url)
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null)
      })
    return () => {
      cancelled = true
    }
  }, [value, size])

  if (!dataUrl) return <div style={{ width: size, height: size }} aria-hidden="true" />
  return (
    <img
      src={dataUrl}
      width={size}
      height={size}
      alt={label ?? t('QrCode.code_qr', { value })}
      className={className}
      style={{ background: '#fff', borderRadius: 8, padding: 6, boxSizing: 'content-box', maxWidth: '100%', height: 'auto' }}
    />
  )
}
